export default __webpack_public_path__ + "e70e71df7d188ad5fc59f198e49d6882.png";